import React from "react";
import LowpolyPageHero from "./LowpolyPageHero";

const OfficeTitle = ({ text, text2 }) => {
  return <LowpolyPageHero text={text} text2={text2} />;
};

export default OfficeTitle;
